"use strict";

module.exports = function (accumulator, printJob, product, component) {
  return Math.ceil((parseFloat(component.quantity) + 3) / 12);
};